export default {
    state: {
        selectedForm: null, // To store the selected form
        formTitle: '',      // To store the title for the new form
        formDescription: '', // To store the description for the new form
    },
    mutations: {
        setSelectedFormRevisionId(state, form) {
            state.selectedFormRevisionId = form;
        },
        setFormRevisionId(state, formRevisionId) {
            state.formRevisionId = formRevisionId;
        },
        setFormTitle(state, title) {
            state.formTitle = title;
        },
        setFormBodyId(state, formBodyId) {
            state.formBodyId = formBodyId;
        },
        setFormId(state, title) {
            state.formId = title;
        },
        setFormDescription(state, description) {
            state.formDescription = description;
        },
    },
    actions: {
        // Add actions for API calls if needed
    },
}
